import { render } from "./TagInput.vue?vue&type=template&id=478cefc4&scoped=true"
import script from "./TagInput.vue?vue&type=script&lang=js"
export * from "./TagInput.vue?vue&type=script&lang=js"

import "./TagInput.vue?vue&type=style&index=0&id=478cefc4&scoped=true&lang=css"
import "./TagInput.vue?vue&type=style&index=1&id=478cefc4&lang=scss"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-478cefc4"]])

export default __exports__